import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}rest/i18n/form`

export default {
  get(formId) {
    return ApiService.get(`${resourceUrl}/data?id=${formId}`)
  },
  post(data) {
    return ApiService.post(`${resourceUrl}/translate`, data)
  },
}
